module.exports = __webpack_public_path__ + "img/catalog-icon_active.a67f06ba.svg";